import { GET_COMMERCIAL_RECONCILIATION, RESET_COMMERCIAL_RECONCILIATION } from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState } from "../../types";

const initialState: BaseAsyncReducerState = {
    loading: false,
    error: false,
    success: false,
    data: []
}
  
function getCommercialReconciliationReducer(state = initialState, action: AppAction) {
    if (action.type === RESET_COMMERCIAL_RECONCILIATION) {
        return initialState
    } else {
        return defaultAsyncReducer(state, action, GET_COMMERCIAL_RECONCILIATION);
    }
}

export default getCommercialReconciliationReducer;